import React, { memo } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import type { DialogProps } from '@mui/material';
import './scss/dialog.style.scss';
import { ReactComponent as CloseIcon } from '../../static/images/svg/mingcute_close-fill.svg';


// *********************
// Type
// *********************

export declare type DialogHeaderProps = {
    // 对话框标题
    title?: string;
    /** 自定义标题区（如多色文案）；设置时优先于纯文本 title 展示 */
    titleContent?: React.ReactNode;
    // 标题图标
    TitleIcon?: JSX.Element;
    // 是否隐藏对话框关闭图标
    isHiddenCloseIcon?: boolean;
    /** 与 MUI `Dialog` 一致，便于由公共弹窗转发 */
    onClose?: DialogProps['onClose'];
    rightNode?: JSX.Element;
    // 标题颜色
    titleColor?: 'info' | 'success' | 'error';
    // 标题位置
    titleAlign?: 'center' | 'left'
}

/**
 * 对话框头部组件
 * @param props
 * @returns
 */
function DialogHeader(props: DialogHeaderProps) {

    // *********************
    // View
    // *********************

    const { TitleIcon, title, titleContent, isHiddenCloseIcon, onClose, rightNode } = props;
    /** 自定义 titleContent 时标题区须占满一行，关闭钮才能贴齐纸面右侧（与 `header-action-box` 的 absolute 布局配合） */
    const titleBoxStyle: React.CSSProperties | undefined = titleContent
        ? props.titleAlign === 'center'
            ? { flex: 1, minWidth: 0, justifyContent: 'center' }
            : { flex: 1, minWidth: 0, width: '100%' }
        : undefined;
    return (
        <Box className='dialog-header' sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: props.titleAlign === 'center' ? 'center' : 'flex-start',
            position: 'relative',
            width: '100%',
        }}>
            <div className='header-title-box' style={titleBoxStyle}>
                {
                    TitleIcon &&
                    TitleIcon
                }
                {
                    titleContent
                }
                {
                    !titleContent && title &&
                    <Typography
                        variant='h3'
                        className={`header-title ${props.titleColor}`}
                    >
                        {title}
                    </Typography>
                }
            </div>
            <div className='header-action-box'>
                {
                    rightNode
                }
                {
                    rightNode ? <div className='line' /> : null
                }
                {
                    !isHiddenCloseIcon &&
                    <IconButton
                        className='header-close-icon'
                        onClick={() => onClose?.({} as object, 'backdropClick')}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            </div>
        </Box>
    )
}

export default memo(DialogHeader)